import React from 'react';
import { useSelectedBusiness } from '../UserAccess/useSelectedBusiness';

const chipListMaxHeight = '11rem';

export default function ProfileSiteAccess() {
  const business = useSelectedBusiness();
  const { siteRestricted, numberOfSites } = business;
  const assignedSites = [...business.assignedSites].sort((a, b) => a.name.localeCompare(b.name));

  if (numberOfSites === 0 || (siteRestricted && assignedSites.length === 0)) return null;

  const chip = (key: string, label: string) =>
    <li key={key} style={{ minWidth: 0 }}>
      <span
        className="badge rounded-pill bg-light text-dark fw-normal border text-truncate mw-100"
        title={label}>
        {label}
      </span>
    </li>;

  return (
    <div data-testid="profile-site-access" className="px-3 pt-3 pb-2 border-top">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <span
          id="profileSiteAccessLabel"
          className="d-inline-flex align-items-center gap-1 text-uppercase text-muted fw-semibold small">
          <i className="bi-geo-alt-fill" aria-hidden="true" />
          Site access
        </span>
        {siteRestricted && <span className="small text-muted">{`${assignedSites.length} of ${numberOfSites}`}</span>}
      </div>
      <ul
        className="list-unstyled d-flex flex-wrap gap-1 mb-0 overflow-auto"
        style={{ maxHeight: chipListMaxHeight }}
        aria-labelledby="profileSiteAccessLabel"
        tabIndex={siteRestricted && assignedSites.length > 1 ? 0 : undefined}>
        {siteRestricted
          ? assignedSites.map(site => chip(site.id, site.name))
          : chip('all', `All sites (${numberOfSites})`)}
      </ul>
    </div>
  );
}
